export default {
    title: 'Inställningar',
    profile: 'Min profil',
    name: 'Namn',
    company: 'Företag',
    email: 'E-post',
    language: 'Språk',
    logout: 'Logga ut',
    sessionWarning: {
        title: 'Sessionen håller på att gå ut',
        message: 'Din session kommer att gå ut om {minutes} minuter och {seconds} sekunder på grund av inaktivitet. Spara ditt arbete och fortsätt för att stanna inloggad.',
        timeFormat: '{minutes} minuter och {seconds} sekunder kvar',
        secondsFormat: '{seconds} sekunder kvar',
        continue: 'Fortsätt arbeta',
        extending: 'Förlänger...',
        logout: 'Logga ut nu'
    },
    inactivity: {
        title: 'Välkommen tillbaka!',
        message: 'Du har varit inaktiv ett tag. Du kan logga ut och fortsätta senare eller fortsätta nu.',
        logout: 'Logga ut',
        continue: 'Fortsätt nu'
    }
};
